
function validateAccess(data, http) {
    return http.post('app/users/open_external_access_request', {
        data,
    });
}


export default {
    validateAccess,
}